// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import { TransactionsList as TransactionsListView } from '@client/banks/components/shared/transactions-list';
import { NavigationControls } from '@client/banks/layouts/navigation-controls';
import { ScreenLayout } from '@client/banks/layouts/screen-layout';
import { Translation } from '@shared/ui-kit/providers/translation-provider/translation';
import { defineComponent } from '@shared/ui-kit/utils/define-component';
import catalogStyles from '../styles/institution-catalog.module.css';
import { useTransactionsList } from './use-transactions-list';

export const TransactionsListStep = defineComponent({
  displayName: 'TransactionsListStep',
  useSetup: useTransactionsList,
  View: ({
    items,
    isEmpty,
    canFinalize,
    onAdd,
    onImportExcel,
    onEdit,
    onDelete,
  }) => (
    <ScreenLayout
      className="!overflow-hidden !pt-6"
      actions={
        <NavigationControls
          nextStep="review-summary"
          previousStep="institution-manual"
          nextDisabled={!canFinalize}
          nextLabel={
            <Translation
              i18nKey="aggregator.create-bank.finalize"
              ns="aggregator"
            />
          }
        />
      }
    >
      <div className={catalogStyles['step-body-fill']}>
        <TransactionsListView
          items={items}
          isEmpty={isEmpty}
          onAdd={onAdd}
          onImportExcel={onImportExcel}
          onEdit={onEdit}
          onDelete={onDelete}
        />
      </div>
    </ScreenLayout>
  ),
});
